import { Routes } from '@angular/router';

import { loadChangePasswordPage } from '@auth-pages';
import { getClientUrl } from '@core';
import { authGuard, errorGuard, testGuard } from '@guards';
import { loadAccessibilityPage, loadCookiesPage, loadErrorPage, loadTestdevPage } from '@pages';
import { moduleResolver, translationResolver } from '@resolvers';
import { REPORTING_SERVICE_CODE } from './common/reporting.constants';

export let routes: Routes = [];

const clientUrl = getClientUrl();

if (clientUrl.length) {
    routes = [
        // Must come first: the next route also matches `/client` (no child) and would render nothing.
        { path: clientUrl, pathMatch: 'full', redirectTo: `/${clientUrl}/signIn` },
        {
            path: `${clientUrl}`,
            children: [
                {
                   path: 'testdev',
                   loadComponent: loadTestdevPage,
                   title: 'Test development',
                   canActivate: [testGuard]
                },
                {
                    path: 'login-details',
                    loadComponent: loadChangePasswordPage,
                    title: 'Login details',
                    canActivate: [authGuard]
                },
                {
                    path: 'accessibility',
                    loadComponent: loadAccessibilityPage,
                    title: 'Accessibility',
                    data: { moduleCode: REPORTING_SERVICE_CODE },
                    resolve: { module: moduleResolver }
                },
                {
                    path: 'cookies',
                    loadComponent: loadCookiesPage,
                    title: 'Cookies',
                    data: { moduleCode: REPORTING_SERVICE_CODE },
                    resolve: { module: moduleResolver }
                },
                {
                    path: 'error',
                    loadComponent: loadErrorPage,
                    title: 'Error',
                    canActivate: [errorGuard]
                },
            ]
        },
        {
            path: `${clientUrl}`,
            loadChildren: () => import('@auth-pages').then(r => r.IdentityRoutes),
        },
        {
            // Reporting pages hang directly off /{client}, with no module segment.
            path: `${clientUrl}`,
            loadChildren: () => import('@reporting/features/reporting.routes').then(r => r.ReportingRoutes),
            data: { moduleName: 'REPORTING', moduleCode: REPORTING_SERVICE_CODE },
            resolve: { module: moduleResolver, translation: translationResolver },
        },
        { path: '**', redirectTo: `${clientUrl}/signIn`, pathMatch: 'full' }
    ];
}
else {
    routes = [{ path: '**', redirectTo: 'error', pathMatch: 'full' }];
    console.error('Client not found');
}
